<template>
  <div class="d-flex align-center flex-gap">
    <v-btn icon v-if="showBackButton">
      <v-icon size="32" @click="$router.back()"> mdi-arrow-left-bold-box-outline </v-icon>
    </v-btn>
    <h2>{{ title }}</h2>
  </div>
</template>

<script>
export default {
  name: 'headerLabel',
  props: {
    title: String,
    showBackButton: { type: Boolean, default: true },
  },
};
</script>
